module.exports = __webpack_public_path__ + "img/m_genre.9cacb279.svg";